import { Badge } from './badge';

enum StatusStyle {
  Blue = 'blue',
  Gray = 'gray',
  Red = 'red',
  Green = 'green',
  Yellow = 'yellow',
  Indigo = 'indigo',
  Purple = 'purple',
  Pink = 'pink',
  Gold = 'gold'
}

const badgeVariants: Record<StatusStyle, string> = {
  [StatusStyle.Blue]:
    'bg-blue-100 text-blue-800 font-medium me-2 px-2.5 py-0.5 border-none rounded max-h-[20px] text-[12px] hover:bg-blue-100 hover:text-blue-800',
  [StatusStyle.Gray]:
    'bg-gray-100 text-gray-800 font-medium me-2 px-2.5 py-0.5 border-none rounded  max-h-[20px] text-[12px] hover:bg-gray-100 hover:text-gray-800',
  [StatusStyle.Red]:
    'bg-red-100 text-red-800 font-medium me-2 px-2.5 py-0.5 border-none rounded max-h-[20px] text-[12px] hover:bg-red-100 hover:text-red-800',
  [StatusStyle.Green]:
    'bg-green-100 text-green-800 font-medium me-2 px-2.5 py-0.5 border-none rounded max-h-[20px] text-[12px] hover:bg-green-100 hover:text-green-800',
  [StatusStyle.Yellow]:
    'bg-yellow-100 text-yellow-800 font-medium me-2 px-2.5 py-0.5 border-none rounded max-h-[20px] text-[12px] hover:bg-yellow-100 hover:text-yellow-800',
  [StatusStyle.Indigo]:
    'bg-indigo-100 text-indigo-800 font-medium me-2 px-2.5 py-0.5 border-none rounded max-h-[20px] text-[12px] hover:bg-indigo-100 hover:text-indigo-800',
  [StatusStyle.Purple]:
    'bg-purple-100 text-purple-800 font-medium me-2 px-2.5 py-0.5 border-none rounded max-h-[20px] text-[12px] hover:bg-purple-100 hover:text-purple-800',
  [StatusStyle.Pink]:
    'bg-pink-100 text-pink-800 font-medium me-2 px-2.5 py-0.5 border-none rounded max-h-[20px] text-[12px] hover:bg-pink-100 hover:text-pink-800',
  [StatusStyle.Gold]:
    'bg-yellow-300 text-yellow-800 font-medium me-2 px-2.5 py-0.5 border-none rounded max-h-[20px] text-[12px] hover:bg-yellow-400 hover:text-yellow-800'
};

interface Props {
  status: StatusStyle;
  text?: string;
  className?: string;
}

function StatusBadges({ status, text, className = '' }: Props) {
  return (
    <Badge className={`${className} ${badgeVariants[status]}`}>
      {text ?? ''}
    </Badge>
  );
}

export { StatusBadges, StatusStyle };
